import { Store } from 'vuex';

import mutations from './mutations';
import * as getters from './getters';
import * as actions from './actions';

export default new Store({
  strict: true,

  mutations,
  getters,
  actions,

  state: {
    items: [],
    subscribers: {},
    counter: 0,
    refreshing: false,
  },
});



// WEBPACK FOOTER //
// ./resources/assets/js/view-stack/store/index.js